var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "store-selector" },
    [
      _c(
        "el-form",
        {
          staticClass: "store-selector__filter",
          attrs: { inline: true, size: "small" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "店铺分类" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { clearable: "", placeholder: "全部分类" },
                  on: { change: _vm.handleCategoryChange },
                  model: {
                    value: _vm.categoryId,
                    callback: function ($$v) {
                      _vm.categoryId = $$v
                    },
                    expression: "categoryId",
                  },
                },
                _vm._l(_vm.merSelect, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "storeTable",
          attrs: {
            data: _vm.filteredMerchantList,
            border: "",
            size: "small",
            "max-height": "360",
            "row-key": _vm.getMerchantId,
            "empty-text": _vm.loading ? "加载中" : "暂无店铺",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "50",
              "reserve-selection": true,
              selectable: _vm.isRowSelectable,
            },
          }),
          _c("el-table-column", {
            attrs: { label: "ID", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.getMerchantId(scope.row)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "店铺名称",
              "min-width": "170",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.name))]),
                    _vm.isRowDisabled(scope.row)
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "store-selector__tag",
                            attrs: { size: "mini", type: "info" },
                          },
                          [_vm._v("已关联")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "realName", label: "联系人", width: "110" },
          }),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "联系方式", width: "130" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }